<template>
    <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50">
        <h3>Service Charge</h3>
        <p class="margin_bottom">Service charge, management fee and commencement date for current year</p>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                Service Charge
            </label>
            <div class="md-layout-item md-size-40">
                <ValidationProvider name="Service Charge" rules="required|min_value:50|max_value:2147483647" v-slot="{ passed, failed }">
                    <md-field class="val-inset" :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <span class="md-prefix">&pound;</span>
                        <md-input type="number" v-model="serviceCharge.value" min="50" step="100" max="2147483647"></md-input>
                        <span class="md-helper-text">Service Charge per annum</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                S/C Fee
            </label>
            <div class="md-layout-item md-size-40">
                <ValidationProvider name="Service Charge Fee" rules="required|min_value:50|max_value:2147483647" v-slot="{ passed, failed }">
                    <md-field class="val-inset" :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <span class="md-prefix">&pound;</span>
                        <md-input type="number" v-model="serviceCharge.fee" min="50" step="100" max="2147483647"></md-input>
                        <span class="md-helper-text">Service Charge Fee per annum</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                Commencement
            </label>
            <div class="md-layout-item md-size-40">
                <ValidationProvider name="Service Charge Commencement Date" rules="required" v-slot="{ passed, failed }">
                    <md-datepicker v-model="serviceCharge.date" :md-model-type="mdType" md-immediately :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-datepicker>
                </ValidationProvider>
            </div>
        </div>

    </div>
</template>
<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { extend } from "vee-validate";
    import { required, min, max, min_value, max_value } from "vee-validate/dist/rules";
    extend("required", required);
    extend("min", min);
    extend("max", max);
    extend("min_value", min_value);
    extend("max_value", max_value);

    export default {
        name: "BuildingServiceCharge",
        components: {
            SlideYDownTransition
        },
        props: {
            serviceCharge: {
                value: null,
                fee: null,
                date: null, //https://vuematerial.io/components/datepicker/
            }
        },
        computed: {
            mdType() {
                return String
            }
        }
    }
</script>

<style lang="scss">
    .md-field.val-inset {
        i.md-icon{
            right: 13px;
        }
    }
</style>


